module.exports = __webpack_public_path__ + "static/SamAdams-Page_28-78a7597d5bb4ea0c44946c5eed63e698.jpg";